/* eslint-disable no-restricted-syntax */
import fp from 'lodash/fp'

export const createPrefix = (prefix, endpoints) => {
  prefix = fp.isFunction(prefix) ? prefix : fp.constant(prefix)

  for (const [key, fn] of Object.entries(endpoints)) {
    if (fp.isArray(fn)) {
      const [subPrefix, endpointsFn] = fn

      const subPrefixValue = fp.isFunction(subPrefix)
        ? subPrefix
        : fp.constant(subPrefix)

      const subPrefixFn = (...args) =>
        `${prefix(...args)}${subPrefixValue(...args.slice(prefix.length))}`
      prefix[key] = createPrefix(subPrefixFn, endpointsFn)
      continue
    }

    const safeFn = fp.isString(fn) ? fp.constant(fn) : fn

    if (fp.isFunction(prefix)) {
      prefix[key] = (...rest) => {
        const prefixArgs = rest.slice(prefix.length)
        return `${prefix(...prefixArgs)}${safeFn(...rest)}`
      }

      continue
    }

    prefix[key] = (...args) => `${prefix}${safeFn(...args)}`
  }

  return prefix
}
